import { DARK_THEME, LIGHT_THEME } from '../Types/themeTypes';

export const switchToDarkTheme = () => ({
	type: DARK_THEME
});

export const switchToLightTheme = () => ({
	type: LIGHT_THEME
});
